import React from "react";
import { Box, Card, Tab, Tabs, AppBar } from "@mui/material";
import {
  Timeline as TimelineIcon,
  FitnessCenter as FitnessCenterIcon,
  Restaurant as RestaurantIcon,
  CalendarToday as CalendarIcon,
  Photo as PhotoIcon,
  Notes as NotesIcon,
  VideoLibrary as VideoLibraryIcon,
} from "@mui/icons-material";

// Import all enhanced tab components
import EnhancedProgressTab from "./EnhancedProgressTab";
import EnhancedTrainingTab from "./EnhancedTrainingTab";
import EnhancedNutritionTab from "./EnhancedNutritionTab";
import EnhancedDailyReportsTab from "./EnhancedDailyReportsTab";
import EnhancedPhotosTab from "./EnhancedPhotosTab";
import EnhancedNotesTab from "./EnhancedNotesTab";
import EnhancedVideosTab from "./EnhancedVideosTab";

// Tab Panel Component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const ClientTabs = ({
  activeTab,
  setActiveTab,
  client,
  dailyReport,
  currentWorkout,
  exerciseData,
  nutritionChartData,
  calendarModifiers,
  modifierStyles,
  selectedDay,
  chartType,
  setChartType,
  setSelectedDay,
  setBodyMeasurementOpen,
  photoUpdate,
  setPhotoUpdate,
  handlers,
  mealPlans,
  getMealPlanById,
  organizationId,
}) => {
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Card>
      <AppBar position="static" color="default" elevation={0}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          <Tab icon={<TimelineIcon />} label="Goals" />
          <Tab icon={<FitnessCenterIcon />} label="Training" />
          <Tab icon={<RestaurantIcon />} label="Nutrition" />
          <Tab icon={<CalendarIcon />} label="Daily Reports" />
          <Tab icon={<PhotoIcon />} label="Photos" />
          <Tab icon={<NotesIcon />} label="Notes" />
          <Tab icon={<VideoLibraryIcon />} label="Videos" />
        </Tabs>
      </AppBar>

      <TabPanel value={activeTab} index={0}>
        {/* Progress Tab - Enhanced Nutrition & Cardio Goals */}
        <EnhancedProgressTab client={client} handlers={handlers} />
      </TabPanel>

      <TabPanel value={activeTab} index={1}>
        {/* Training Tab - Enhanced */}
        <EnhancedTrainingTab
          exerciseData={exerciseData}
          currentWorkout={currentWorkout}
          chartType={chartType}
          setChartType={setChartType}
          clientId={client?.uid}
          organizationId={organizationId || client?.organizationId}
        />
      </TabPanel>

      <TabPanel value={activeTab} index={2}>
        {/* Nutrition Tab - Enhanced */}
        <EnhancedNutritionTab
          client={client}
          mealPlans={mealPlans}
          getMealPlanById={getMealPlanById}
          nutritionChartData={nutritionChartData}
          organizationId={organizationId || client?.organizationId}
        />
      </TabPanel>

      <TabPanel value={activeTab} index={3}>
        {/* Daily Reports Tab - Enhanced */}
        <EnhancedDailyReportsTab
          client={client}
          calendarModifiers={calendarModifiers}
          modifierStyles={modifierStyles}
          selectedDay={selectedDay}
          dailyReport={dailyReport}
          setBodyMeasurementOpen={setBodyMeasurementOpen}
          onDayClick={(day, modifiers = {}) => {
            if (modifiers.disabled) return;
            handlers.handleButtonEvent("Day Click", "Clients", client.uid);
            setSelectedDay(day);
          }}
        />
      </TabPanel>

      <TabPanel value={activeTab} index={4}>
        {/* Photos Tab - Enhanced */}
        <EnhancedPhotosTab
          client={client}
          photoUpdate={photoUpdate}
          setPhotoUpdate={setPhotoUpdate}
        />
      </TabPanel>

      <TabPanel value={activeTab} index={5}>
        {/* Notes Tab - Enhanced */}
        <EnhancedNotesTab client={client} />
      </TabPanel>

      <TabPanel value={activeTab} index={6}>
        {/* Videos Tab - Enhanced */}
        <EnhancedVideosTab client={client} />
      </TabPanel>
    </Card>
  );
};

export default ClientTabs;
